import { CollapseGroup } from '@consta/uikit/CollapseGroup'
import { Text } from '@consta/uikit/Text'
import {
  getContextMenuCollectionAction,
  selectContextMenuItemsByType,
  selectUploadedFile,
  useAppDispatch,
  useAppSelector,
} from '@core/core/store'
import type { Nullable } from 'common/types'
import type { FC } from 'react'
import { useEffect, useRef, useState } from 'react'

import { filterDraftOptions } from './helpers'
import { ProjectObjectProperties } from './projectObjectProperties'
import css from './ProjectObjects.css'
import { Tree } from './Tree'
import { TreeCustomContextMenu } from './TreeCustomContextMenu'
import type { ChangeMenuVisibilityFuncType, ProjectObjectsPropsType as PropsType } from './types'

const properties = [{ label: 'Свойства', content: <ProjectObjectProperties /> }]

export const ProjectObjects: FC<PropsType> = ({
  objectTreeNode,
  showObjectsProperties,
  setObjectTreeNode,
  getActionFromItem,
}) => {
  const [isShowContextMenu, setIsShowContextMenu] = useState(false)
  const contextMenuRef = useRef<Nullable<HTMLButtonElement>>(null)

  const dispatch = useAppDispatch()

  const changeMenuVisibility: ChangeMenuVisibilityFuncType = (refBtn, objectTreeNode) => {
    contextMenuRef.current = refBtn.current
    setIsShowContextMenu(true)
    setObjectTreeNode(objectTreeNode)
  }

  const contextMenuItems = useAppSelector(state =>
    selectContextMenuItemsByType(state, objectTreeNode?.elementType ?? 'unknown'),
  )
  const filteredItems = filterDraftOptions(contextMenuItems, objectTreeNode)

  const uploadedFiles = useAppSelector(selectUploadedFile)

  useEffect(() => {
    console.dir(`file uploading status: ${JSON.stringify(uploadedFiles)}`)
  }, [uploadedFiles])

  useEffect(() => {
    dispatch(getContextMenuCollectionAction())
  }, [])

  return (
    <>
      <TreeCustomContextMenu
        isOpen={isShowContextMenu}
        items={filteredItems}
        contextMenuRef={contextMenuRef}
        getActionFromItem={getActionFromItem}
        setIsShowContextMenu={setIsShowContextMenu}
      />

      <div className={css.container}>
        <Text className={css.title} size="s" view="secondary">
          Объекты
        </Text>

        <Tree changeMenuVisibility={changeMenuVisibility} />

        {!!showObjectsProperties && (
          <CollapseGroup
            className={css.treeBarCollapseTab}
            horizontalSpace="s"
            iconPosition="right"
            items={properties}
          />
        )}
      </div>
    </>
  )
}
